import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
import { createFromIconfontCN } from '@ant-design/icons-vue';
import { iconFontJS } from '@/assets/icon/iconfont.js'
import { setupAxiosAuthInterceptors } from '@/utils/auth';
const IconFont = createFromIconfontCN({
  scriptUrl: iconFontJS,
});


// axios.defaults.baseURL = Object.is(process.env.NODE_ENV, 'production')? window.location.protocol + "//www.indoorlink.com" : '';
axios.defaults.baseURL = 'https://tts.indoorlink.com';
axios.defaults.headers.post["Content-type"] = "application/json";

setupAxiosAuthInterceptors({ axiosInstance: axios });

// axios.defaults.headers.common['Host'] = '192.168.0.203:50000';

// axios.defaults.withCredentials = true;

createApp(App).use(store).use(store).use(router).use(Antd).component('IconFont', IconFont).mount('#app')
